import { Flex } from '@/_components';
import styles from './QuestionnaireHeader.module.css';
import type { FC } from 'react';
import type { QuestionnaireHeaderProps } from './QuestionnaireHeader.types';
import { getClasses } from '@/_utils/classnames';

export const QuestionnaireHeader: FC<QuestionnaireHeaderProps> = ({
  children,
}) => {
  const questionnaireHeaderClasses = getClasses(styles.questionnaireHeader);

  return (
    <Flex
      isBetween={true}
      className={questionnaireHeaderClasses}
      isYCentered={true}
    >
      {children}
    </Flex>
  );
};
